import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, getInlineLoader } from "../Helpers";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_DEBTS,
  STR_CHARITY,
  STR_EXPENSES,
  STR_INCOME,
  STR_INSURANCE,
  STR_INVESTMENTS,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_SAVINGS,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME,
  STR_VIEW_MORE,
  STR_UTT_CALCULATOR,
  STR_LOAN_CALCULATOR,
  STR_BOND_CALCULATOR,
  STR_LEARN_MORE,
  STR_CALCULATORS,
  STR_UTT_MONTHLY_INVESTMENT_CALC,
  STR_UTT_SINGLE_SUM_INVESTMENT_CALC,
  STR_CONTACT_US
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCall, MdEmail, MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import { GiBrain, GiPayMoney } from "react-icons/gi";
import { TbCalculator, TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import { PiStudent } from "react-icons/pi";
import MobileInterface from "../MobileInterface";
import { FaInstagram, FaTelegram, FaWhatsapp } from "react-icons/fa";

export default function ContactUs(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    setReady(true);
  }



  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <h6 className="mSectionTitle">
						{STR_CONTACT_US[appContext.language]}
					</h6>

          <div className="row">

            <div className="col-md-12">
              <div className="row" style={{ marginTop: "10px", marginBottom: "30px", }}>
                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink(`https://wa.me/${appContext.systemParams.whatsappSupportPhone}`)
                    }}
                  >
                    <FaWhatsapp className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      WhatsApp
                    </h6>
                  </div>
                </div>

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink('https://www.instagram.com/afyamingle_app/')
                    }}
                  >
                    <FaInstagram className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      Instagram
                    </h6>
                  </div>
                </div>

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink(`tel:${appContext.systemParams.normalSupportPhone}`)
                    }}
                  >
                    <MdCall className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      {appContext.systemParams.normalSupportPhone}
                    </h6>
                  </div>
                </div>

              </div>
            </div>



          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}